import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  reset(event) {
    if (event.detail.success) {
      this.element.reset()

      // Clear Lexxy rich text editors via custom event.
      // Do NOT touch innerHTML directly — Lexical manages the DOM internally
      // and setting innerHTML causes a "replaceChildren" NotFoundError.
      this.element.querySelectorAll("lexxy-editor").forEach((el) => {
        el.dispatchEvent(new CustomEvent("lexxy:clear", { bubbles: true }))
      })
    }
  }
}
